/**
 * API клієнт для doc.payment_orders (Фаза 2.1 #2).
 */
import { api } from './client';
import type { Page } from './catalogs';

export type PaymentDirection = 'IN' | 'OUT';
export type PaymentOrderState = 'DRAFT' | 'SENT_TO_BANK' | 'EXECUTED' | 'CANCELLED';

export interface PaymentOrder {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  posted: boolean;
  posted_at: string | null;
  deletion_mark: boolean;
  comment: string | null;
  direction: PaymentDirection;
  state: PaymentOrderState;
  contractor_id: string | null;
  bank_account_id: string;
  contract_id: string | null;
  cash_flow_item_id: string | null;
  currency_id: string;
  amount_currency: string;
  amount_uah: string;
  payment_purpose: string;
  sent_to_bank_at: string | null;
  executed_at: string | null;
  cancelled_at: string | null;
  cancellation_reason: string | null;
  related_bank_payment_id: string | null;
  related_bank_receipt_id: string | null;
  related_currency_operation_id: string | null;
  external_source?: string | null;
  created_at: string;
  updated_at: string;
}

export interface PaymentOrderCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  comment?: string | null;
  direction: PaymentDirection;
  contractor_id?: string | null;
  bank_account_id: string;
  contract_id?: string | null;
  cash_flow_item_id?: string | null;
  currency_id: string;
  amount_currency: string;
  amount_uah: string;
  payment_purpose: string;
}

export type PaymentOrderUpdate = Partial<Omit<PaymentOrderCreate, 'organization_id' | 'direction'>>;

export const paymentOrders = {
  list: (params?: {
    organization_id?: string;
    state?: PaymentOrderState;
    direction?: PaymentDirection;
    limit?: number;
    offset?: number;
  }) => api.get<Page<PaymentOrder>>('/documents/payment-orders', { params }).then((r) => r.data),
  get: (id: string) => api.get<PaymentOrder>(`/documents/payment-orders/${id}`).then((r) => r.data),
  create: (payload: PaymentOrderCreate) =>
    api.post<PaymentOrder>('/documents/payment-orders', payload).then((r) => r.data),
  update: (id: string, payload: PaymentOrderUpdate) =>
    api.patch<PaymentOrder>(`/documents/payment-orders/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/documents/payment-orders/${id}`).then(() => undefined),
  sendToBank: (id: string) =>
    api.post<PaymentOrder>(`/documents/payment-orders/${id}/send-to-bank`).then((r) => r.data),
  execute: (id: string) =>
    api.post<PaymentOrder>(`/documents/payment-orders/${id}/execute`).then((r) => r.data),
  cancel: (id: string, cancellation_reason: string) =>
    api.post<PaymentOrder>(`/documents/payment-orders/${id}/cancel`, { cancellation_reason }).then((r) => r.data),
  post: (id: string) =>
    api.post<PaymentOrder>(`/documents/payment-orders/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<PaymentOrder>(`/documents/payment-orders/${id}/unpost`).then((r) => r.data),
};
